export default "__VITE_ASSET__Cx5CCh8C__"